﻿import { Grid, Paper, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { FC, useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUILoadingLinear } from '../../../../atomic/atoms';
import { updateCustomerRequest } from '../../CustomerManagement.helper';
import { CustomerCommand } from '../../../../services/command';
import moment from 'moment';
import Swal from 'sweetalert2';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { UpdateCustomerStatus } from '../../../../types/enums/updateCustomerStatus-enum';
import { CMIP } from './customerInformationPaper.classes';

interface IProps {
    datas?: any;
    refresh?: any;
}

export const CustomerInformationPaper: FC<IProps> = ({ datas, refresh }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(1);
    const [disableButton, setDisableButton] = useState(false);
    const [customerUpdateRequest, setCustomerUpdatRequest] = useState<updateCustomerRequest>({
        customerId: datas.customer.customerId,
        emailAddress: datas.customer.email,
        firstName: datas.customer.firstName,
        lastName: datas.customer.lastName,
        phoneNumber: datas.customer.phoneNumber,
        hasValidatedPhoneNumber: datas.customer.hasValidatedPhoneNumber,
        dateOfBirth: datas.customer.dateOfBirth,
        emailOptIn: datas.customer.emailOptIn,
        smsOptIn: datas.customer.smsOptIn,
        callOptIn: datas.customer.callOptIn,
        cultureCode: datas.customer.cultureCode,
        languageId: datas.customer.languageId,
    });
    const UpdateCustomer = async () => {
        setLoading(true);
        CustomerCommand.UpdateCustomer(customerUpdateRequest)
            .then((res: any) => {
                if (res.error) {
                    console.info(res.error);
                    Swal.fire('', ' ', 'error');
                } else if (res.model?.updateCustomerStatus === UpdateCustomerStatus.ValidateMailSentAndDetailsUpdated) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'UyarÄ±',
                        text: `${customerUpdateRequest.emailAddress} ${t('customerInformation.valideEmailMessage')}`,
                    });
                    refresh();
                } else {
                    Swal.fire('', ' ', 'success');
                    refresh();
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };
    const UpdateCustomerPassword = () => {
        Swal.fire({
            text: t('customerInformation.passwordResetMessage'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.yes'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.customerId = datas.customer.customerId;
                CustomerCommand.SendPasswordResetSms(params);
                Swal.fire(t('customerInformation.passwordResetSmsMessage'), ' ', 'success');
                // onUpdate();
            }
        });
    };
    useEffect(() => {
        const savedTimestamp = localStorage.getItem('timestamp');
        if (savedTimestamp) {
            const timestamp = parseInt(savedTimestamp, 10);
            const currentTime = new Date().getTime();
            const elapsedTime = currentTime - timestamp;

            if (elapsedTime >= 10000) {
                setDisableButton(false);
            } else {
                setDisableButton(true);
                const remainingTime = 10000 - elapsedTime;
                setTimeout(() => {
                    setDisableButton(false);
                }, remainingTime);
            }
        }
    }, []);

    const handleSendEmailButton = () => {
        setTimeout(() => {
            setDisableButton(true);
        }, 100);
        if (!disableButton) {
            let req = { customerId: datas.customer.customerId };
            CustomerCommand.SendCustomerPhoneChangeMail(req).then((res: any) => {
                if (res) {
                    setStatus(2);
                    if (res.operationStatus) {
                        setStatus(2);
                        setTimeout(() => {
                            setDisableButton(false);
                        }, 10000);
                        Swal.fire('', ' ', 'success');
                    } else {
                        Swal.fire('Hata', ' ', 'error');
                    }
                } else {
                    Swal.fire(t('general.serviceError'), ' ', 'error');
                    setTimeout(() => {
                        setDisableButton(false);
                    }, 10000);
                }
            });
        }
    };

    return (
        <Paper className={CMIP.page} style={{ height: '100%', overflow: 'auto' }}>
            <SCUILoadingLinear display={loading} />
            <Grid className={CMIP.mainGrid} container display={'flex'} sx={{ padding: '2rem' }}>
                <Grid
                    className={CMIP.columnPersonal}
                    container
                    sx={{ margin: '1rem' }}
                    size={{
                        xl: 4,
                        lg: 4,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Grid
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={CMIP.inputTextfieldFirstName}
                            id="outlined-basic"
                            label={t('general.name')}
                            defaultValue={customerUpdateRequest.firstName}
                            fullWidth
                            size="small"
                            sx={{ marginBottom: '2rem', minWidth: '100%' }}
                            onChange={(e) =>
                                setCustomerUpdatRequest({
                                    ...customerUpdateRequest,
                                    firstName: e.target.value.trim(),
                                })
                            }
                        />
                    </Grid>
                    <Grid
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={CMIP.inputTextfieldLastName}
                            id="outlined-basic"
                            label={t('general.surname')}
                            defaultValue={customerUpdateRequest.lastName}
                            fullWidth
                            size="small"
                            sx={{ marginBottom: '2rem', minWidth: '100%' }}
                            onChange={(e) =>
                                setCustomerUpdatRequest({
                                    ...customerUpdateRequest,
                                    lastName: e.target.value.trim(),
                                })
                            }
                        />
                    </Grid>
                    <Grid
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={CMIP.inputTextfieldEmail}
                            id="outlined-basic"
                            label={t('general.eMail')}
                            defaultValue={customerUpdateRequest.emailAddress}
                            fullWidth
                            size="small"
                            sx={{ marginBottom: '2rem', minWidth: '100%' }}
                            onChange={(e) =>
                                setCustomerUpdatRequest({
                                    ...customerUpdateRequest,
                                    emailAddress: e.target.value.trim(),
                                })
                            }
                        />
                    </Grid>
                    <Grid
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <TextField
                            className={CMIP.inputTextfieldBirthday}
                            fullWidth
                            id="date"
                            label={customerUpdateRequest.dateOfBirth ? t('customerInformation.birthday') : ''}
                            type="date"
                            sx={{ minWidth: '100%' }}
                            defaultValue={moment(customerUpdateRequest.dateOfBirth).format('YYYY-MM-DD')}
                            onChange={(e) =>
                                setCustomerUpdatRequest({
                                    ...customerUpdateRequest,
                                    dateOfBirth: e.target.value.trim(),
                                })
                            }
                        />
                    </Grid>
                </Grid>
                <Grid
                    className={CMIP.columnActions}
                    container
                    sx={{ margin: '1rem' }}
                    spacing={2}
                    size={{
                        xl: 7,
                        lg: 8,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Grid
                        className={CMIP.actionsTopRow}
                        container
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexDirection: 'row',
                        }}
                    >
                        {datas.customer?.backofficeCustomerPhoneUpdatedShowStatusTemplate && (
                            <Grid
                                className={CMIP.blockPhoneUpdate}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                }}
                            >
                                <Grid sx={{ marginBottom: '1rem' }}>
                                    <strong>{t('customerInformation.phoneNumberUpdate')}</strong>
                                </Grid>
                                <Grid>
                                    <SCUIButton
                                        className={CMIP.inputButtonSendPhoneMail}
                                        text={
                                            status === 1
                                                ? t('customerInformation.updateEmailSendMessage')
                                                : t('customerInformation.trySend')
                                        }
                                        disabled={disableButton}
                                        type="primary"
                                        sizeType="default"
                                        size="s"
                                        style={{ width: '180px' }}
                                        onClick={() => handleSendEmailButton()}
                                    ></SCUIButton>
                                </Grid>
                            </Grid>
                        )}
                        {datas.customer?.backofficeCustomerPasswordResetShowStatusTemplate && (
                            <Grid
                                className={CMIP.blockCredentialReset}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                }}
                            >
                                <Grid sx={{ marginBottom: '1rem' }}>
                                    <strong>{t('customerInformation.passwordReset')}</strong>
                                </Grid>
                                <Grid>
                                    <SCUIButton
                                        className={CMIP.inputButtonCredentialResetSms}
                                        text={t('customerInformation.passwordResetSmsSend')}
                                        type="primary"
                                        sizeType="default"
                                        size="s"
                                        style={{ width: '180px' }}
                                        onClick={() => UpdateCustomerPassword()}
                                    ></SCUIButton>
                                </Grid>
                            </Grid>
                        )}
                    </Grid>
                    {status !== 1 && (
                        <Grid
                            className={CMIP.mailSentNotice}
                            sx={{
                                marginLeft: '6rem',
                                color: 'yellowgreen',
                                fontSize: '1rem',
                            }}
                        >
                            {' '}
                            <InfoOutlinedIcon sx={{ color: 'yellowgreen' }}></InfoOutlinedIcon>{' '}
                            {datas.customer?.userName + ' ' + t('customerInformation.endMailText')}{' '}
                        </Grid>
                    )}
                    <Grid
                        size={{
                            xl: 12,
                            lg: 12,
                            md: 12,
                            xs: 12,
                        }}
                    >
                        <FormControl className={CMIP.fieldCustomerType}>
                            <FormLabel id="demo-row-radio-buttons-group-label">
                                {' '}
                                <h4>{t('customerInformation.customerType')}:</h4>{' '}
                            </FormLabel>
                            <RadioGroup className={CMIP.inputRadioGroupCustomerType} row>
                                <FormControlLabel
                                    value="musteri"
                                    control={<Radio />}
                                    label={t('customerInformation.customer')}
                                    checked={datas.customer.customerType === 2 ? true : false}
                                />
                                <FormControlLabel
                                    value="personel"
                                    control={<Radio />}
                                    label={t('customerInformation.personel')}
                                    checked={datas.customer.customerType === 1 ? true : false}
                                />
                                <br></br>
                                <FormControlLabel
                                    value="notpersonel"
                                    control={<Radio />}
                                    label={t('customerInformation.dontCustomer')}
                                    checked={datas.customer.customerType === 6 ? true : false}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid
                        sx={{ marginTop: 0.5 }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 6,
                            xl: 6,
                        }}
                    >
                        <SCUIButton
                            className={CMIP.inputButtonUpdateCustomer}
                            text={t('customerInformation.updateCustomerInformation')}
                            type="primary"
                            sizeType="fixed"
                            buttonType="submit"
                            size={'m'}
                            fullwidth
                            onClick={UpdateCustomer}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
};

